import { createAnimations } from "@tamagui/animations-css";

import { springs, toCssTransition } from "./springs";

export const animations = createAnimations({
  press: toCssTransition(springs.press),
  enter: toCssTransition(springs.enter),
  exit: toCssTransition(springs.exit),
  expand: toCssTransition(springs.expand),
  overlay: toCssTransition(springs.overlay),
  backdrop: toCssTransition(springs.backdrop),
  reveal: toCssTransition(springs.reveal),
  fade: toCssTransition(springs.fade),
  expressive: toCssTransition(springs.expressive),
  draw: toCssTransition(springs.draw),
});
